import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltung-uebersicht';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksVeranstaltungUebersichtEffects {

    VeranstaltungUebersicht$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_UEBERSICHT),
        mergeMap((x: ac.GetVeranstaltungUebersichtAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungUebersicht(x.veranstaltungUebersichtRequest).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungUebersichtErfolgreichAction(result, x.veranstaltungUebersichtRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungUebersichtFehlerAction(error, x.veranstaltungUebersichtRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ControllingQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ControllingQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.ControllingQueryService);
        }
        return this.service;
    }
}
